import React, { useMemo } from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { makePdfStyleSheet } from "./styles";
import logoHorizontal from "assets/images/logo-horizontal.png";

export interface PDFFooterProps {
  logo?: string;
  tenant: string;
  endereco1: string;
  endereco2: string;
  styles?: Record<string, any>;
}

function PDFFooter({
  tenant,
  logo,
  endereco1,
  endereco2,
  styles,
}: PDFFooterProps) {
  const _styles = useMemo(() => styles ?? makePdfStyleSheet(), [styles]);

  return (
    <View style={_styles.footer} wrap={false}>
      <View style={_styles.flexRow}>
        <View style={_styles.footerDescription}>
          <Text style={_styles.footerTitle}>{tenant}</Text>
          <Text>{endereco1}</Text>
          <Text>{endereco2}</Text>
        </View>

        <Image src={logo || logoHorizontal} style={_styles.logoFooter} />
      </View>
    </View>
  );
}

export default PDFFooter;
